<template>
    <div class="search-box">
        <header>
            <div class="search">
                <div class="search-input">
                    <form action="#">
                        <input 
                            type="search" 
                            placeholder="搜索位置/品牌/酒店名"
                            v-model="inputValue"
                            ref="searchInput"
                        >
                    </form>
                </div>
                <div @click="clear">取消</div>
            </div>
        </header>
        <main>
            <div class="history" v-if="history.length">
                <div class="history-nav">
                    <span>最近搜索</span>
                    <span @click="clearHistory">清空<img src="@/assets/hotel/img/home/clear.png" alt="clear"></span>
                </div>
                <div class="content">
                    <div 
                        v-for="(item,index) of history" 
                        :key="index"
                        @click="search(item)"
                    >
                        {{item.name}}
                    </div>
                </div>
            </div>
            <div class="hot">
                <div class="hot-nav"><img src="@/assets/hotel/img/search/hot_sq.png" alt="sq">热门商圈</div>
                <div class="content">
                    <div 
                        v-for="(item,index) of hotList[0]" 
                        :key="index"
                        @click="search(item)"
                    >
                        {{item.name}}
                    </div>
                </div>
            </div>
            <div class="hot">
                <div class="hot-nav"><img src="@/assets/hotel/img/search/hot_jd.png" alt="jd">热门景点</div>
                <div class="content">
                    <div 
                        v-for="(item,index) of hotList[1]" 
                        :key="index"
                        @click="search(item)"
                    >
                        {{item.name}}
                    </div>
                </div>
            </div>
            <div class="hot">
                <div class="hot-nav"><img src="@/assets/hotel/img/search/hot_pp.png" alt="pp">热门品牌</div>
                <div class="content">
                    <div 
                        v-for="(item,index) of hotList[2]" 
                        :key="index"
                        @click="search(item)"
                    >
                        {{item.name}}
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import { getHotAroundData } from '@/pages/hotel/api'
import { mapState,mapMutations } from 'vuex'
import debounce from '@/providers/debounce'
    export default {
        data() {
            return {
                hotList:[],//热门列表
                history:[],//历史记录
                inputValue:'',//搜索值
                debounceSearchInput:null,//正在搜索高频防抖
            }
        },
        computed:{
            ...mapState({
                searchCity:state => state.hotel.searchCity,
                searchValue:state => state.hotel.searchValue,
            }),
         },
        mounted() {
            this.inputValue = this.searchValue.name
            this.debounceSearchInput = debounce(this.sarchInputing, 500); //函数防抖开始
            this.$refs.searchInput.addEventListener('keypress',(e)=>{
                let keycode = e.keyCode;
                if(keycode=='13') {
                    e.preventDefault();  
                    //请求搜索接口 
                    if(this.inputValue){
                        this.setState([{name:'searchValue',value:{name:this.inputValue}}])
                        this.search({name:this.inputValue})
                    }
                }
            })
            if(localStorage.history){
                this.history = JSON.parse(localStorage.history);
            }
            getHotAroundData(this.searchCity.value.code ? this.searchCity.value.code : 1).then((res)=>{
                res.forEach(item => {
                    if(item.poi_name=='商圈'){
                        this.$set(this.hotList,0,item.poi_list)
                    }else if(item.poi_name=='景点'){
                        this.$set(this.hotList,1,item.poi_list)
                    }else if(item.poi_name=='品牌'){
                        this.$set(this.hotList,2,item.poi_list)
                    }
                });
            })
        },
        destroyed(){
            this.debounceSearchInput = null
        },
        methods: {
            ...mapMutations(['setState']),
            search(obj){//搜索
                if(localStorage.history){
                    let history = JSON.parse(localStorage.history);
                    let bool = history.some((item)=>{
                        return item.name==obj.name
                    })
                    if(!bool){
                        history.unshift(obj);
                        if(history.length>8){
                            history.pop();
                        }
                        localStorage.history = JSON.stringify(history);
                    }
                }else{
                    localStorage.history = JSON.stringify([obj]);
                }
                this.setState([{name:'searchValue',value:obj}]);
                this.go('back');
            },
            sarchInputing(){
                this.setState([{name:'searchValue',value:{name:this.inputValue}}]);
            },
            clearHistory(){//清空搜索框
                this.history = [];
                localStorage.removeItem('history')
            },
            clear(){
                this.setState([{name:'searchValue',value:{}}]);
                this.go('back');
            },
            go(path){//跳转
                if(path=='back'){
                    history.go(-1);
                }else{
                    this.$router.push(path);
                }
            },
        },
    }
</script>

<style lang="less">
    html{
        font-size: calc(var(--sizeScale2)*10px);
    }
    .search-box{
        min-height: 100%;
        background-color: #FBFBFB;
        header{
            padding: 4.4rem 2rem 0 2rem;
            .search{
                display: flex;
                justify-content: space-between;
                margin-bottom: 3rem;
                .search-input{
                    width: 28.3rem;
                    height: 4.5rem;
                    form{
                        height: 100%;
                    }
                    input{
                        width: 100%;
                        height: 100%;
                        border: none;
                        border-radius: 2.25rem;
                        outline: none;
                        -webkit-appearance: none;
                        box-shadow: 0 0.5rem 1rem 0 rgba(19, 19, 19, 0.07);
                        padding:0 2rem;
                        font-size: 1.6rem;
                        &::placeholder{
                            font-size: 1.6rem;
                            color: #CCCCCC;
                            line-height: 2.2rem;
                        }
                        &::-webkit-search-cancel-button{
                            -webkit-appearance: none;  //此处去掉默认的小×
                        }
                    }
                }
                >div:nth-of-type(2){
                    flex: 1;
                    font-size: 1.6rem;
                    font-weight: 400;
                    color: #333333;
                    text-align: right;
                    line-height: 4.5rem;
                }
            }
        }
        main{
            .history{
                margin-top: 3rem;
                .history-nav{
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2rem;
                    color: #999999;
                    span{
                        &:nth-of-type(1){
                            font-size: 1.4rem;
                            line-height: 2rem;
                        }
                        &:nth-of-type(2){
                            display: inline-flex;
                            align-items: center;
                            font-size: 1.2rem;
                            img{
                                width: 1.5rem;
                                height: 1.5rem;
                                // vertical-align: middle;
                                margin-left: 0.5rem;
                            }
                        }
                    }
                }
            }
            .hot{
                margin-top: 1rem;
                .hot-nav{
                    font-size: 1.4rem;
                    line-height: 2rem;
                    color: #999999;
                    padding: 0 2rem;
                    display: flex;
                    align-items: center;
                    img{
                        width: 1.6rem;
                        height: 1.6rem;
                        margin-right: 0.5rem;
                    }
                }
            }
            .content{
                padding: 2rem;
                padding-right: 1rem;
                >div{
                    display: inline-block;
                    height: 3.6rem;
                    max-width: 13.2rem;
                    line-height: 3.6rem;
                    text-align: center;
                    border-radius: 0.5rem;
                    background-color: #EEEEEE;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding: 0 1rem;
                    box-sizing: border-box;
                    vertical-align: top;
                    font-size: 1.4rem;
                    font-weight: 500;
                    color: #333333;
                    &:not(:last-child){
                        margin-bottom: 1rem;
                        margin-right: 1rem;
                    }
                }
            }
        }
    }
</style>